<template>
  <div class="order-input">
    <div class="main-title">
      <span> <i class="el-icon-folder-opened"></i> 订单录入 </span>
    </div>
    <div class="input-table">
      <!-- <form @submit.prevent="onSubmit"> -->

      <table class="input-form" v-loading="loading">
        <thead>
          <th colspan="6" class="emphasis">创建订单</th>
        </thead>
        <tbody>
          <tr>
            <td style="min-width: 120px">游玩线路</td>
            <td>
              <el-select v-model="form.LineId" filterable placeholder="根据线路名搜索" @change="setRouteInfo">
                <el-option
                  v-for="item in options.routes"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </td>
            <td style="min-width: 120px">游玩日期</td>
            <td>
              <el-date-picker
                v-model="form.PlayTime"
                type="date"
                placeholder="请选择游玩日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </td>
            <td style="min-width: 120px">同行总人数(含本人)</td>
            <td>
              <el-input-number v-model="form.TotoalCount" :min="1" disabled></el-input-number>
            </td>
          </tr>
          <tr>
            <td style="min-width: 120px">成人票（人）</td>
            <td>
              <el-input-number
                v-model="form.AdultCount"
                :min="0"
                @blur="AdultCountChange(form.AdultCount)"
                @input="AdultCountChange(form.AdultCount)"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">儿童票（人）</td>
            <td>
              <el-input-number
                v-model="form.ChildrenCount"
                :min="0"
                @blur="ChildrenCountChange(form.ChildrenCount)"
                @input="ChildrenCountChange(form.ChildrenCount)"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">老年人票（人）</td>
            <td>
              <el-input-number
                v-model="form.ElderlyCount"
                :min="0"
                @blur="ElderlyCountChange(form.ElderlyCount)"
                @input="ElderlyCountChange(form.ElderlyCount)"
              ></el-input-number>
            </td>
          </tr>
          <tr>
            <td style="min-width: 120px">成人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.AdultPrice"
                :min="0"
                :precision="2"
                @input="AdultPriceChange"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">儿童价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ChildrenPrice"
                :min="0"
                :precision="2"
                @input="ChildrenPriceChange"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">老年人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ElderlyPrice"
                :min="0"
                :precision="2"
                @input="ElderlyPriceChange"
              ></el-input-number>
            </td>
          </tr>
          <tr>
            <td style="min-width: 120px">总价（元）</td>
            <td>
              <el-input-number v-model="form.AllPrice" :min="0" :precision="2" ></el-input-number>
            </td>
            <td>餐厅名称</td>
            <td>
              <el-input v-model="form.RestaurantName" placeholder="请输入餐厅名称"></el-input>
            </td>
            <td>餐厅价格（元）</td>
            <td>
              <el-input-number v-model="form.RestaurantPrice" :min="0" :precision="2"></el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="emphasis">信息来源</td>
          </tr>
          <tr>
            <td>线上</td>
            <td>
              <el-radio-group v-model="form.OnLine" @change="selOnline">
                <el-radio label="同程">同程</el-radio>
                <el-radio label="飞猪">飞猪</el-radio>
                <el-radio label="携程">携程</el-radio>
                <el-radio label="途牛">途牛</el-radio>
                <el-radio label="驴妈妈">驴妈妈</el-radio>
              </el-radio-group>
            </td>
            <td>微信公众号</td>
            <td>
              <el-input v-model="form.WeChatAccount" placeholder="请输入微信公众号" @input="WeChatAccountChange" />
            </td>
            <td>其他</td>
            <td>
              <el-input placeholder="请输入其他" v-model="form.Other" @input="OtherChange" />
            </td>
          </tr>
          <tr>
            <td>线下</td>
            <td colspan="2">
              <el-input v-model="form.Offline" placeholder="请输入旅行社" @input="OfflineChange" />
            </td>
            <td>个人</td>
            <td colspan="2">
              <el-input v-model="form.Personal" placeholder="请输入个人" @input="PersonalChange" />
            </td>
          </tr>
          <tr>
            <td colspan="6" class="emphasis">行程安排</td>
          </tr>
          <tr style="height: 45px">
            <td colspan="6"></td>
          </tr>
          <div class="subtable-tab" v-show="tableVisible">
            <div
              v-for="(item, index) in table"
              :key="index"
              class="mouse-pointer tab-item"
              :class="{ 'sub-selected': currentSubId === item.id }"
              @click="switchSubtable(item.id)"
            >
              <div>第{{ item.id + 1 }}天</div>
            </div>
          </div>
          <tr v-show="tableVisible">
            <td colspan="2">行程项目</td>
            <td colspan="2">行程时间(分钟)</td>
            <td colspan="2">行程类型</td>
          </tr>
          <tr v-for="item in table[currentSubId].arrangement" :key="item.proId" v-show="tableVisible">
            <td colspan="2">{{ item.Projects }}</td>
            <td colspan="2">
              {{ item.TimeSpan }}
              <!-- {{ item.StartTime | getProjectTime(item.EndTime) }} -->
            </td>
            <td colspan="2">
              {{ item.PointId | getProjectType(options.projects) }}
            </td>
          </tr>
          <tr>
            <td :rowspan="form.newListTourist.length + 2">游客信息</td>
            <td>游客姓名</td>
            <td>手机号</td>
            <td colspan="2">游客证件</td>
            <td>团队负责人</td>
          </tr>
          <tr v-for="(item, index) in form.newListTourist" :key="index + 1">
            <td>
              <el-input v-model="item.Name" placeholder="请输入游客姓名"></el-input>
            </td>
            <td>
              <el-input v-model="item.Tel" placeholder="请输入游客手机号"></el-input>
            </td>

            <td>
               <el-select v-model="item.CertificatesType" placeholder="请选择证件类型">
                <el-option
                  v-for="item in optionsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="item.IDNumber" placeholder="请输入游客证件"></el-input>
            </td>
            <td>
              <el-checkbox v-model="item.IsMain" @change="switchMainVisitor(item)">是</el-checkbox>
            </td>
          </tr>

          <tr>
            <td colspan="5">
              <el-button-group>
                <el-button type="success" size="mini" @click="handleVisitor('plus')" v-if="false">扫描身份证</el-button>
                <el-button type="primary" size="mini" @click="handleVisitor('plus')">继续添加</el-button>
                <el-button type="danger" size="mini" @click="handleVisitor('minus')">删除行</el-button>
                <!-- <el-button type="info" size="mini"><a :href="'/api/co/Itineraries/DownloadTouristTemplant?sessionId='+sessionId"  style="color: white;">下载导入模板</a></el-button>
                <el-button type="warning" size="mini" @click="excelInputDialog = true" >批量导入</el-button> -->
              </el-button-group>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="text-align: center; padding-top: 40px">
        <el-button type="success" size="medium" @click="submit('form')" :loading="loadingSubmit">保存</el-button>
        <el-button type="primary" size="medium" @click="reset">重置</el-button>
      </div>
      <!-- </form> -->

    </div>
  </div>
</template>

<script>
import { getToken, getCookie } from '@/common/auth'
import ValidationProvider from '@/common/vee-validator'
import { ValidationObserver, validate } from 'vee-validate'
import ROUTE from '@/api/route'
import Order from '@/api/order'
// import SCENIC from "@/api/scenic";

// import Trip from '@/api/trip'
import { mapState } from 'vuex'
export default {
  name: 'OrderInput',
  data() {
    return {
      loadingSubmit:false,
      optionsType:[{
          value: '身份证',
          label: '身份证'
        }, {
          value: '港澳通行证',
          label: '港澳通行证'
        }, {
          value: '台湾通行证',
          label: '台湾通行证'
        },{
          value: '护照',
          label: '护照'
      }],

      sessionId:"",

      config: {
        LineId: '线路名称', //线路Id
        PlayTime: '游玩时间', //游玩时间
        TotoalCount: '同行总人数(含本人)', //总人数(含自己)
        AdultCount: '成人票', //成人个数
        ChildrenCount: '儿童票', //儿童个数
        ElderlyCount: '老年人票', //老年人个数
        AdultPrice: '成人价格', //成人价格
        ChildrenPrice: '儿童价格', //儿童价格
        ElderlyPrice: '老年人价格', //老年人价格
        AllPrice: '总价格', //总价格
        RestaurantPrice: '餐饮价格', //餐饮价格
      },
      form: {
        RestaurantName: '', //餐厅名称
        RestaurantPrice: 0, //餐饮价格

        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        ElderlyPrice: 0, //老年人价格
        AllPrice: 0, //总价格

        TotoalCount: 0, //总人数(含自己)
        ElderlyCount: 0, //老年人个数
        ChildrenCount: 0, //儿童个数
        AdultCount: 0, //成人个数

        LineId: '', //线路Id
        PlayTime: '', //游玩时间

        OnLine: '', //线上
        WeChatAccount: '', //微信公众号
        Offline: '', //线下
        Personal: '', //个人
        Other: '',

        //游客信息表
        newListTourist: [{ Name: '', Tel: '', IDNumber: '',CertificatesType:'身份证', IsMain: false }],
      },
      loading: false,
      currentSubId: 0,
      tableVisible: false,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],
      mainSelected: false,
    }
  },
  inject: ['dateFormat'],
  methods: {
   
    //成人个数变化时
    AdultCountChange(val) {
      var _self = this
      _self.form.AdultCount = parseInt(val)
      // _self.form.TotoalCount =
      //   parseInt(_self.form.AdultCount) + parseInt(_self.form.ElderlyCount) + parseInt(_self.form.ChildrenCount)
      _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));

      // let inputCount = _self.form.newListTourist.length
      // if (_self.form.TotoalCount > inputCount) {
      //   for (let i = 0; i < _self.form.TotoalCount - inputCount; i++)
      //     _self.form.newListTourist.push({
      //       Name: '',
      //       Tel: '',
      //       IDNumber: '',
      //       IsMain: false,
      //     })
      // } else if (_self.form.TotoalCount < inputCount) {
      //   for (let i = 0; i < inputCount - _self.form.TotoalCount; i++)
      //     _self.form.newListTourist.splice(inputCount - i - 1, 1)
      // } else {
      // }
    },
    ChildrenCountChange(val) {
      var _self = this
      _self.form.ChildrenCount = parseInt(val)
      // _self.form.TotoalCount =
      //   parseInt(_self.form.AdultCount) + parseInt(_self.form.ElderlyCount) + parseInt(_self.form.ChildrenCount)
    _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));

      // let inputCount = _self.form.newListTourist.length
      // if (_self.form.TotoalCount > inputCount) {
      //   for (let i = 0; i < _self.form.TotoalCount - inputCount; i++)
      //     _self.form.newListTourist.push({
      //       Name: '',
      //       Tel: '',
      //       IDNumber: '',
      //       IsMain: false,
      //     })
      // } else if (_self.form.TotoalCount < inputCount) {
      //   for (let i = 0; i < inputCount - _self.form.TotoalCount; i++)
      //     _self.form.newListTourist.splice(inputCount - i - 1, 1)
      // } else {
      // }
    },
    ElderlyCountChange(val) {
      var _self = this
      _self.form.ElderlyCount = parseInt(val)
      // _self.form.TotoalCount =
      //   parseInt(_self.form.AdultCount) + parseInt(_self.form.ElderlyCount) + parseInt(_self.form.ChildrenCount)
     _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));

      // let inputCount = _self.form.newListTourist.length
      // if (_self.form.TotoalCount > inputCount) {
      //   for (let i = 0; i < _self.form.TotoalCount - inputCount; i++)
      //     _self.form.newListTourist.push({
      //       Name: '',
      //       Tel: '',
      //       IDNumber: '',
      //       IsMain: false,
      //     })
      // } else if (_self.form.TotoalCount < inputCount) {
      //   for (let i = 0; i < inputCount - _self.form.TotoalCount; i++)
      //     _self.form.newListTourist.splice(inputCount - i - 1, 1)
      // } else {
      // }
    },

    //成人价格变化时
    AdultPriceChange(val) {
      var _self = this
      _self.form.AdultPrice = parseFloat(val)
      _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ChildrenPriceChange(val) {
      var _self = this
      _self.form.ChildrenPrice = parseFloat(val)
    _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ElderlyPriceChange(val) {
      var _self = this
      _self.form.ElderlyPrice = parseFloat(val)
     _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },

    selOnline(val) {
      var _self = this
      _self.form.OnLine = val
      if (val) {
        _self.form.Other = ''
        _self.form.Offline = ''
        _self.form.Personal = ''
      }
    },
    OtherChange(val) {
      var _self = this
      _self.form.Other = val
      if (val) {
        _self.form.OnLine = ''
        _self.form.Offline = ''
        _self.form.Personal = ''
      }
    },
    OfflineChange(val) {
      var _self = this
      _self.form.Offline = val
      if (val) {
        _self.form.OnLine = ''
        _self.form.WeChatAccount = ''
        _self.form.Personal = ''
        _self.form.Other = ''
      }
    },
    PersonalChange(val) {
      var _self = this
      _self.form.Personal = val
      if (val) {
        _self.form.OnLine = ''
        _self.form.WeChatAccount = ''
        _self.form.Offline = ''
        _self.form.Other = ''
      }
    },
    WeChatAccountChange(val) {
      var _self = this
      _self.form.WeChatAccount = val
      if (val) {
        _self.form.Offline = ''
        _self.form.Personal = ''
      }
    },
    //设置路线详情
    setRouteInfo(Id) {
      ROUTE.getRouteDetail({ Id }).then((res) => {
        if (res.status === 'success') {
          if (Array.isArray(res.content.dataAll)) {
            this.tableVisible = true
            this.table = res.content.dataAll.map((v, i) => {
              return {
                id: i,
                arrangement: [...v.dataList],
              }
            })
          }
          if (res.content.GetLineMessage != null) {
            this.form.RestaurantName = res.content.GetLineMessage.RestaurantName
            this.form.RestaurantPrice = res.content.GetLineMessage.RestaurantPrice
            this.form.AdultPrice = res.content.GetLineMessage.AdultPrice
            this.form.ChildrenPrice = res.content.GetLineMessage.ChildrenPrice
            this.form.ElderlyPrice = res.content.GetLineMessage.ElderlyPrice
          }
        } else {
          this.$message.error('线路详情获取失败!')
        }
      })
    },
    //子表操作
    switchSubtable(subId) {
      this.currentSubId = subId
    },
    //游客操作
    handleVisitor(type) {
      if (type === 'plus') {
        this.form.TotoalCount++
        this.form.newListTourist.push({
          Name: '',
          Tel: '',
          IDNumber: '',
          CertificatesType:'身份证',
          IsMain: false,
        })
      } else if (type === 'minus') {
        if (this.form.newListTourist.length > 1) {
          this.form.TotoalCount--
          this.form.newListTourist.pop()
        } else {
          this.$message.error('至少录入一位游客信息!')
        }
      }
    },
    //提交
    submit(formName) {
      var _self = this
  
      if (_self.form.newListTourist.length > _self.form.TotoalCount) {
        _self.$message.error('游客信息数量大于同行总人数')
        return
      }

      for (var key in _self.form) {
        if (
          (_self.form[key] == undefined || _self.form[key].toString().trim().length == 0) &&
          _self.config[key] != undefined
        ) {
          _self.$message.error(_self.config[key] + '未填写')
          return
        }
      }

      let flag = false
      _self.form.newListTourist.forEach((item) => {
        if (
          item.Name == '' ||
          item.Name == undefined ||
          item.CertificatesType == '' ||
          item.CertificatesType == undefined ||
          item.IDNumber == '' ||
          item.IDNumber == undefined
        ) {
          _self.$message.error('游客信息未填写完整')
          flag = true
          return false
        }
      })
      if (flag) {
        return
      }
      if (parseInt(_self.form.TotoalCount) != parseInt(_self.form.newListTourist.length)) {
        _self.$message.error('同行总人数与录入游客信息数量不符合!')
        return false
      }
      if (_self.form.ElderlyCount + _self.form.ChildrenCount + _self.form.AdultCount != _self.form.TotoalCount) {
        _self.$message.error('票价人数错误!')
        return false
      }
      if (new Date(_self.form.PlayTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        _self.$message.error('游玩日期不能小于当前时间!')
        return false
      }
      if (!_self.mainSelected) {
        _self.$message.error('请选择一位团队负责人!')
        return false
      }
      _self.loading = true;
      _self.loadingSubmit=true;
      Order.addOrder(_self.form).then((res) => {
        if (res.status === 'success') {
          _self.$message.success('添加成功!');
          _self.reset();
          _self.loadingSubmit=false;
        } else {
          _self.$message.error(res.msg);
          _self.loadingSubmit=false;
        }
        _self.loading = false;
      })

      // validate('19951339969', 'required|mobile').then((res) => {

      //   if (!res.valid) {
      //     //false
      //     _self.$message.error(res.failedRules.mobile)
      //     return
      //   }
      // })

      // if(_self.form.newListTourist!=null){
      //   var lst=_self.form.newListTourist;
      //   for(let i=0;i<lst.length;i++){
      //     if(lst[i].Tel!="" && lst[i].Tel!=null){
      //       validate(lst[i].Tel,'required|mobile').then(res=>{
      //         if(!res.valid){ //false
      //           _self.$message.error(res.failedRules.mobile);
      //           return false;
      //         }
      //       });
      //     }
      //     else{
      //       _self.$message.error("请输入手机号!");
      //       return false;
      //     }

      //     if(lst[i].IDNumber!="" && lst[i].IDNumber!=null){
      //       validate(lst[i].IDNumber,'required|idCard').then(res=>{
      //         if(!res.valid){ //false
      //           _self.$message.error(res.failedRules.idCard);
      //           return false;
      //         }
      //       });
      //     }else{
      //       _self.$message.error("请输入身份证号!");
      //       return false;
      //     }

      //   }
      // }

      // _self.$refs[formName].validate("dasd",'required|positiveInteger').then((success) => {
      //   if (success) {
      //     if (parseInt(_self.form.TotoalCount) != parseInt(_self.form.newListTourist.length)) {
      //       // _self.$message.error("同行人数不能大于游客信息数量!");
      //       _self.$message.error('同行总人数与录入游客信息数量不符合!')
      //       return false
      //     }
      //     if (_self.form.ElderlyCount + _self.form.ChildrenCount + _self.form.AdultCount != _self.form.TotoalCount) {
      //       _self.$message.error('票价人数错误!')
      //       return false
      //     }
      // if (new Date(_self.form.PlayTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
      //   _self.$message.error('游玩日期不能小于当前时间!')
      //   return false
      // }
      //     if (!_self.mainSelected) {
      //       _self.$message.error('请选择一位团队负责人!')
      //       return false
      //     }
      //     _self.loading = true
      //     Order.addOrder(_self.form).then((res) => {
      //       if (res.status === 'success') {
      //         _self.$message.success('添加成功!')
      //         _self.reset()
      //       } else {
      //         _self.$message.error(res.msg)
      //       }
      //       _self.loading = false
      //     })
      //   } else {
      //     _self.$message.error('请补全信息!')
      //   }
      // })
    },
    //重置表单
    reset() {
      this.form = {
        RestaurantName: '', //餐厅名称
        RestaurantPrice: 0, //餐饮价格
        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        AllPrice: 0, //总价格
        AdultCount: 0, //成人个数

        LineId: '', //线路Id
        PlayTime: '', //游玩时间
        ElderlyCount: '', //免票数
        ChildrenCount: '', //半票数
        TotoalCount: 0, //总人数

        OnLine: '', //线上
        WeChatAccount: '', //微信公众号
        Offline: '', //线下
        Personal: '', //个人
        Other: '',

        //游客信息表
        newListTourist: [{ Name: '', Tel: '', IDNumber: '',CertificatesType:'身份证', IsMain: false }],
      };
      this.tableVisible = false;
    },
    //设置主要游客
    switchMainVisitor(item) {
      this.mainSelected = item.IsMain
      if (!item || !item.Tel) {
        item.IsMain = false
        return false
      }
      this.form.newListTourist.forEach((v) => {
        if (v.Tel !== item.Tel) v.IsMain = false
      })
    },
  },
  created() {},
  mounted() {
    if (Array.isArray(this.options.routes) && this.options.routes.length > 0) {
      this.form.LineId = this.options.routes[0].Id
      this.setRouteInfo(this.form.LineId)
    }

     this.sessionId = getCookie('sessionId');
  },
  filters: {
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type
        }
      }
      return ''
    },
    getProjectTime(start, end) {
      let startTime = +start,
        endTime = +end
      if (isNaN(startTime) || isNaN(endTime)) return ''
      return `${parseInt(startTime / 60)}:${startTime % 60 >= 10 ? startTime % 60 : '0' + (startTime % 60)}
      至 ${parseInt(endTime / 60)}:${endTime % 60 ? endTime % 60 : '0' + (endTime % 60)}`
    },
  },
  computed: {
    ...mapState('trip', {
      options: (state) => {
        return {
          routes: state.routes,
          projects: state.projects,
        }
      },
    }),
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
}
</script>

<style>
 .upload-drag {
  margin: auto;
  text-align: center;
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  color: #606266 !important;
}
</style>
<style scoped lang="less">
.main-title {
  width: 100%;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  background: #efefef;
}
.input-table {
  padding: 20px;
}
.input-form {
  position: relative;
  width: 90%;
  //   min-width: 1400px;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.input-form /deep/ .el-date-editor .el-range-input,
.input-form /deep/ .el-date-editor .el-range-separator {
  margin: 3px;
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 345px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.emphasis {
  font-weight: bolder;
}
// .subtable-tab .subtable-handle {
//   min-width: 100px;
//   border-right: 1px solid #aaa;
// }
// .subtable-tab /deep/ .el-button-group > .el-button {
//   width: 50px;
//   height: 45px;
//   padding: 0;
//   font-size: 18px;
//   // border: none;
// }
</style>
